import { render, staticRenderFns } from "./downloadVideo.vue?vue&type=template&id=4f98ad00&scoped=true&"
import script from "./downloadVideo.vue?vue&type=script&lang=js&"
export * from "./downloadVideo.vue?vue&type=script&lang=js&"
import style0 from "./downloadVideo.vue?vue&type=style&index=0&id=4f98ad00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f98ad00",
  null
  
)

export default component.exports